import type { PageFooterData } from '#/components/PageFooter/types/PageFooterData';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetInternshipsRoutePath } from '#/modules/search/routing/helpers/searchGetInternshipsRoutePath';
import { searchGetJobsRoutePath } from '#/modules/search/routing/helpers/searchGetJobsRoutePath';
import { searchGetOrgsRoutePath } from '#/modules/search/routing/helpers/searchGetOrgsRoutePath';
import { createOrgRoute, postAListingRoute } from '#/routing/routes';

export const pageFooterDataPt: PageFooterData = {
  idealistDays: {
    title: 'Participe',
    links: [
      {
        type: 'our-vision',
        title: 'Nossa visão',
        href: '/pt/days/saiba-mais',
      },
      {
        type: 'spread-the-word',
        title: 'Divulgue',
        href: '/pt/days/convide-um-amigo',
      },
      {
        type: 'plan-ahead',
        title: 'Planeje com antecedência',
        href: '/pt/days/planejar',
      },
      {
        type: 'take-a-logo',
        title: 'Use a logo',
        href: '/pt/simbolo-idealista',
      },
      {
        type: 'support-our-work',
        title: 'Apoie nosso trabalho',
        href: '/pt/doacao',
      },
    ],
  },
  volunteer: null,
  findAJob: {
    title: 'Buscar Emprego',
    links: [
      {
        type: 'jobs',
        title: 'Empregos',
        href: searchGetJobsRoutePath({ locale: I18nLocale.PT }),
      },
      {
        type: 'internships',
        title: 'Estágios',
        href: searchGetInternshipsRoutePath({ locale: I18nLocale.PT }),
      },
      {
        type: 'organizations',
        title: 'Organizações',
        href: searchGetOrgsRoutePath({ locale: I18nLocale.PT }),
      },
      {
        type: 'career-advice',
        title: 'Blog Carreira de Impacto',
        href: '/pt/carreira-impacto?pq=',
      },
    ],
  },
  postOnIdealist: {
    title: 'Anunciar',
    links: [
      {
        type: 'post-a-listing',
        title: 'Vaga ou Evento',
        href: postAListingRoute.with({}),
      },
      {
        type: 'create-org',
        title: 'Cadastre sua Organização',
        href: createOrgRoute.with({}),
      },
      {
        type: 'create-community-group',
        title: 'Cadastre seu Coletivo',
        href: createOrgRoute.with({}),
      },
      {
        type: 'recruitment',
        title: 'Ferramentas para Recrutadores',
        href: '/pt/accion/recursos-org',
      },
    ],
  },
  aboutUs: {
    title: 'Sobre Nós',
    links: [
      {
        type: 'our-story',
        title: 'Nossa História',
        href: '/pt/sobre/idealist',
      },
      {
        type: 'our-team',
        title: 'Nossa Equipe',
        href: '/pt/sobre/equipe',
      },
      {
        type: 'donate',
        title: 'Doações para a Idealist',
        href: '/pt/doacao',
      },
    ],
  },
  contactUs: {
    title: 'Contactar',
    links: [
      {
        type: 'help-center',
        title: 'Central de Atendimento',
        href: '/pt/ajuda',
      },
      {
        type: 'contact-us',
        title: 'Entre em Contato',
        href: '/pt/sobre/contato',
      },
      {
        type: 'terms-of-service',
        title: 'Termos de Serviço (EN)',
        href: '/en/terms-of-service',
      },
      {
        type: 'privacy-policy',
        title: 'Política de Privacidade (EN)',
        href: '/en/privacy-policy',
      },
      {
        type: 'site-map',
        title: 'Mapa do Site',
        href: '/pt/mapa-do-site',
      },
    ],
  },
  missionStatement:
    'Trabalhando com outros, em um espírito de generosidade e respeito mútuo, queremos construir um mundo em que todas as pessoas possam viver com liberdade e dignidade.',
};
